import React from 'react';
import './DetailsSection.css';

export default function AssignmentDetailsSection({
  assignment,
  assignmentInfo,
  isOverdue,
  onToggleCompleted,
  onEdit,
  endeavor,
  navigateToEndeavor,
  navigateToEvent
}) {
  if (!assignment) return null;

  const isFromSyllabus =
    Boolean(assignment.isFromSyllabus) ||
    /SYLLABUS/i.test(String(assignment.source || ''));

  const hasWeight = Number.isFinite(Number(assignment.weightPercent));
  const weightText = hasWeight ? `${Number(assignment.weightPercent)}%` : null;
  const isGroup = Boolean(assignment.groupWork);

  // Normalize priority so we never call toLowerCase() on a non-string
  const PRIORITY_NUM_TO_KEY = {
    0: 'none',
    1: 'low',
    2: 'medium',
    3: 'high',
    4: 'critical'
  };
  const rawPriority = assignment.priority;
  let priorityKey = 'medium';
  if (typeof rawPriority === 'number' && Number.isFinite(rawPriority)) {
    priorityKey = PRIORITY_NUM_TO_KEY[rawPriority] || 'medium';
  } else if (typeof rawPriority === 'string') {
    priorityKey = rawPriority.trim().toLowerCase() || 'medium';
  }
  const priorityLabel = priorityKey.charAt(0).toUpperCase() + priorityKey.slice(1);

  return (
    <div className={`assignment-combined ${isOverdue ? 'overdue' : ''}`}>
      <div className="assignment-top-row">
        <div className="assignment-icon-large">
          {assignment.assignmentType === 'exam' ? '📝' :
           assignment.assignmentType === 'project' ? '💼' :
           assignment.assignmentType === 'quiz' ? '❓' :
           assignment.assignmentType === 'reading' ? '📖' : '📋'}
        </div>
        <div className="assignment-top-meta">
          <h1 className="assignment-title">{assignment.name || assignment.title}</h1>

          <div className="assignment-links-row">
            {isFromSyllabus && (
              <span className="assignment-link-btn" title="Extracted from syllabus">🤖 From Syllabus</span>
            )}
            {hasWeight && (
              <span className="assignment-link-btn" title="Weight">🏷️ {weightText}</span>
            )}
            {isGroup && (
              <span className="assignment-link-btn" title="Group work">👥 Group</span>
            )}
            {endeavor && (
              <button className="assignment-link-btn" onClick={navigateToEndeavor}>
                🎓 {endeavor.name}
              </button>
            )}
            {assignment.eventId && (
              <button className="assignment-link-btn" onClick={navigateToEvent}>
                📅 Related Event
              </button>
            )}
          </div>
        </div>
        <div className="header-actions combined-actions">
          <button
            className={`btn ${assignment.completed ? 'btn-warning' : 'btn-success'}`}
            onClick={onToggleCompleted}
          >
            {assignment.completed ? '↻ Mark Incomplete' : '✓ Mark Complete'}
          </button>
          <button className="btn btn-primary edit-assignment-btn mobile-hide" onClick={onEdit}>✏️ Edit</button>
        </div>
      </div>

      {assignment.description && (
        <div className="assignment-description-block">{assignment.description}</div>
      )}

      <div className="assignment-details-grid">
        <div className="detail-item">
          <button className="detail-item-edit-btn" onClick={onEdit} title="Edit due date">✏️</button>
          <label>Due Date</label>
          <p className={isOverdue ? 'overdue-text' : ''}>
            {assignment.dueDatetime
              ? new Date(assignment.dueDatetime).toLocaleString('en-US', {
                  month: 'short', day: 'numeric', year: 'numeric',
                  hour: 'numeric', minute: '2-digit', hour12: true
                })
              : 'Not set'}
          </p>
        </div>
        <div className="detail-item">
          <button className="detail-item-edit-btn" onClick={onEdit} title="Edit priority">✏️</button>
          <label>Priority</label>
          <p><span className={`priority-badge priority-${priorityKey}`}>
            {priorityLabel}
          </span></p>
        </div>
        <div className="detail-item">
          <button className="detail-item-edit-btn" onClick={onEdit} title="Edit status">✏️</button>
          <label>Status</label>
          <p><span className={`status-badge ${assignment.completed ? 'completed' : (isOverdue ? 'overdue' : 'pending')}`}>
            {assignmentInfo.status}
          </span></p>
        </div>
        {assignment.points != null && (
          <div className="detail-item">
            <button className="detail-item-edit-btn" onClick={onEdit} title="Edit points">✏️</button>
            <label>Points</label>
            <p>{assignment.points}</p>
          </div>
        )}
        {hasWeight && (
          <div className="detail-item">
            <button className="detail-item-edit-btn" onClick={onEdit} title="Edit weight">✏️</button>
            <label>Weight</label>
            <p>{weightText}</p>
          </div>
        )}
        {isGroup && (
          <div className="detail-item">
            <button className="detail-item-edit-btn" onClick={onEdit} title="Edit group work">✏️</button>
            <label>Group Work</label>
            <p>Yes</p>
          </div>
        )}
        <div className="detail-item">
          <button className="detail-item-edit-btn" onClick={onEdit} title="Edit assignment">✏️</button>
          <label>Created</label>
          <p>{assignmentInfo.createdAt}</p>
        </div>
        <div className="detail-item">
          <button className="detail-item-edit-btn" onClick={onEdit} title="Edit assignment">✏️</button>
          <label>Updated</label>
          <p>{assignmentInfo.updatedAt}</p>
        </div>

        {assignment.dueInstructions && (
          <div className="detail-item" style={{ gridColumn: '1 / -1' }}>
            <button className="detail-item-edit-btn" onClick={onEdit} title="Edit due instructions">✏️</button>
            <label>Due Instructions</label>
            <p>{assignment.dueInstructions}</p>
          </div>
        )}
      </div>
    </div>
  );
}